import { useState, useCallback } from 'react';
import { reportesService } from '../services';

export const useReportes = () => {
  const [ventasData, setVentasData] = useState(null);
  const [topProductos, setTopProductos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Obtener reporte de ventas
   */
  const getReporteVentas = useCallback(async (params = {}) => {
    setIsLoading(true);
    setError(null);

    try {
      const result = await reportesService.getReporteVentas(params);

      if (result.success) {
        setVentasData(result.data);
        return {
          success: true,
          data: result.data
        };
      } else {
        setError(result.error || 'Error al cargar reporte de ventas');
        return {
          success: false,
          error: result.error || 'Error al cargar reporte de ventas'
        };
      }
    } catch (error) {
      const errorMessage = 'Error de conexión al cargar reporte de ventas';
      setError(errorMessage);
      console.error('Error loading sales report:', error);
      return {
        success: false,
        error: errorMessage
      };
    } finally {
      setIsLoading(false);
    }
  }, []);

  /**
   * Obtener productos más vendidos
   */
  const getTopProductos = useCallback(async (params = {}) => {
    setIsLoading(true);
    setError(null);

    try {
      const result = await reportesService.getTopProductos(params);

      if (result.success) {
        setTopProductos(result.data);
        return {
          success: true,
          data: result.data
        };
      } else {
        setError(result.error || 'Error al cargar productos más vendidos');
        return {
          success: false,
          error: result.error || 'Error al cargar productos más vendidos'
        };
      }
    } catch (error) {
      const errorMessage = 'Error de conexión al cargar productos más vendidos';
      setError(errorMessage);
      console.error('Error loading top products:', error);
      return {
        success: false,
        error: errorMessage
      };
    } finally {
      setIsLoading(false);
    }
  }, []);

  /**
   * Generar reporte PDF/Excel
   */
  const generarReporte = useCallback(async (tipo, params) => {
    setIsLoading(true);
    setError(null);

    try {
      let result;

      switch (tipo) {
        case 'ventas':
          result = await reportesService.generarReporteVentas(params);
          break;
        case 'inventario':
          result = await reportesService.generarReporteInventario(params);
          break;
        case 'clientes':
          result = await reportesService.generarReporteClientes(params);
          break;
        default:
          throw new Error('Tipo de reporte no válido');
      }

      if (result.success) {
        // Descargar archivo
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `reporte-${tipo}-${new Date().getTime()}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();

        return {
          success: true,
          message: 'Reporte descargado exitosamente'
        };
      } else {
        setError(result.error || 'Error al generar reporte');
        return {
          success: false,
          error: result.error || 'Error al generar reporte'
        };
      }
    } catch (error) {
      const errorMessage = 'Error al generar reporte';
      setError(errorMessage);
      console.error('Error generating report:', error);
      return {
        success: false,
        error: errorMessage
      };
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    // Datos
    ventasData,
    topProductos,

    // Estados
    isLoading,
    error,

    // Funciones
    getReporteVentas,
    getTopProductos,
    generarReporte,
    setError
  };
};
